import capitalize from "lodash/capitalize";

export const capitalizeIntent = (intent: string) => {
    const parts = intent.split("_");
    return parts.map((part, index) => (index === 1 ? capitalize(part) : part)).join("_");
};
